import React, { useState, useEffect } from "react";
import Pagebannerintern from "./pagebanner-intern";
import Offcanvas from "./offcanvas.js";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase.js";

const Pro = () => {
    // Liste des travaux
    const [worksList, setWorksList] = useState([]);
    // Liste des types de prestations
    const [type, setType] = useState("pro-solo");
    // Liste des prestations en solo
    const [items, setItems] = useState([]);
    const [id, setId] = useState(0);
    // Liste des images
    const [imageTab, setImageTab] = useState([]);
    // State pour afficher le offcanvas
    const [display, setDisplay] = useState(false);

    const collectionName = "pro";
            
    async function getProEvents(event) {
        let allWorks = [];
        try {
            const querySnapshot = await getDocs(collection(db, type));  
            

            querySnapshot.forEach((doc) => {
                let work = doc.data();
                work.id = doc.id;
                allWorks.push(work);
            });
        } catch (error) {
            console.error("Erreur lors de la lecture des données:", error);
        }

        return allWorks;
    }

    function changeType(e) {
        setType(e.target.value);
    }

    useEffect(() => {
        getProEvents()
        .then(events => {
            setWorksList(events); // Mets à jour l'état avec le tableau
        })
        .catch(error => {
            console.error("Erreur lors de la récupération des données:", error);
        });
        setTimeout(() => {
            console.log(worksList);
        }, 900);
        
    }, [type]);

    useEffect(() => {
        setItems(worksList);
    }, [type]);

    useEffect(() => {
        const offcanvas = document.querySelector('.mek-offcanvas');
        if (offcanvas) {
            document.querySelector(".mek-offcanvas-close").addEventListener("click", () => {
                setDisplay(false);

                setTimeout(() => {
                    if (offcanvas.dataset.active == "false") {
                        setItems(prevItems => {
                            const newItems = [...prevItems];
                            newItems[offcanvas.id] = false;
                            return newItems;
                        });
                    }
                }, 50);
            });
        }
    }, [display]);

    return (
        <main>
            <Pagebannerintern breadcrumb="Pro" title="Réalisations pro" />
            <section className="pt-4 pt-lg-5">
                {type == 'pro' && (
                    <div className="container pro-list pb-4 pb-lg-5">
                        <div className="row">
                            <p>Au cours de mon parcours en agence, j'ai eu l'occasion de participer à différents types de projets et missions.</p>
                            <p><strong>Attention :</strong> les réalisations présentées ici sont issues de prestations portant sur des outils internes et donc signées au nom des agences pour lesquelles j'ai travaillé. Par respect pour le travail collectif, je me contenterai de décrire les projets d’équipe sans mentionner le nom des agences concernées, ni afficher de visuels du produit final.</p>
                            <p>En effet, dans le domaine du web, les choses évoluent très vite : entre le produit livré au client et sa version mise à jour après notre départ, les modifications successives rendent difficile une représentation fidèle du travail initialement effectué.</p>
                        </div>
                    </div>
                )}
                {/* Affichage des réalisation pro */}
                <div className="container">
                    {/* Boutons de changement de type */}
                    <div className="col-12 pro-buttons mb-3 mb-md-4">
                        <button className={`pro-button ${type == "pro" && ("active")}`} onClick={changeType} value="pro">En agence</button>
                        <button className={`pro-button ${type == "pro-solo" && ("active")}`} onClick={changeType} value="pro-solo">Personnel</button>
                    </div>
                    <h2 className="mb-3 mb-md-4 text-primary">
                        {type == "pro" && (
                            <>Réalisations en agence</>
                        )}
                        {type == "pro-solo" && (
                            <>Réalisations personnels</>
                        )}
                    </h2>
                    <div className="accordion row" id="accordionExample">
                        {worksList.map((item, index) => (
                            <>
                                {/* Prestations en agence */}
                                {type === "pro" && (
                                    <div className="accordion-item col-12 col-lg-6" id={index}>
                                        <h3 className="accordion-header" id={`heading${index}`}>
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${index}`}
                                                aria-expanded="true" aria-controls={`collapse${index}`}>
                                                {item.title}
                                            </button>
                                        </h3>
                                        <div id={`collapse${index}`} className="accordion-collapse collapse" aria-labelledby={`heading${index}`}
                                        data-bs-parent="#accordionExample">
                                            <div className="accordion-body" dangerouslySetInnerHTML={{ __html: item.description }} />
                                        </div>
                                    </div>
                                )}
                                {/* Prestations en solo */}
                                {type === "pro-solo" && (
                                    <div class="col-12 col-sm-6 col-lg-4 realisation-container" id={index}>
                                        <div 
                                        class="realisation-background" 
                                        style={{backgroundImage: `url("${process.env.PUBLIC_URL}/images/${item.miniature}.jpg")`}}>
                                            <h2 class="realisation-title">{item.title}</h2>
                                            <button class="btn btn-primary" onClick={() => {
                                             setId(index);
                                             setDisplay(true);
                                             items[index] = true;
                                             }}>En savoir plus</button>
                                            {display && (
                                                <Offcanvas 
                                                 title={item.title} 
                                                 description={item.description}
                                                 active={items[index]}
                                                 images={item.images}
                                                 id={index}
                                                 type={item.type} />
                                )}
                                        </div>
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    )
};

export default Pro;